export { default } from "./intersect-polygon.module";
